import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { companyInfo } from '../../data/content';

export default function FloatingCTA() {
  return (
    <a 
      href={`tel:${companyInfo.phone.replace(/\D/g,'')}`}
      className="fixed bottom-6 right-6 bg-accent text-white p-4 rounded-full shadow-2xl hover:bg-orange-600 transition-transform hover:scale-110 z-50 flex items-center justify-center"
      aria-label="Call for service"
    >
      <SafeIcon name="Phone" className="text-2xl animate-pulse" />
    </a>
  );
}